import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { CssVarsProvider } from "@mui/joy/styles";
import { CssBaseline, GlobalStyles } from "@mui/joy";
import App from "./App";
import { appTheme, globalStyles } from "./theme";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");
const root = createRoot(rootElement);

root.render(
  <CssVarsProvider theme={appTheme}>
    <CssBaseline />
    <GlobalStyles styles={globalStyles} />
    <Router>
      <App />
    </Router>
  </CssVarsProvider>,
);
